import { useState } from "react";
import { Search, LayoutGrid, List } from "lucide-react";

export default function ListToolbar({ search, onSearch, filters, viewMode, onViewMode, children }) {
  return (
    <div className="flex flex-wrap items-center gap-3 mb-6" data-testid="list-toolbar">
      <div className="relative flex-1 min-w-[200px]">
        <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
        <input type="text" placeholder="Buscar..." value={search} onChange={e => onSearch(e.target.value)}
          className="w-full pl-9 pr-4 py-2 rounded-lg border border-slate-200 bg-white text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all" data-testid="search-input" />
      </div>
      {filters}
      {children}
      <div className="flex border border-slate-200 rounded-lg overflow-hidden" data-testid="view-toggle">
        <button onClick={() => onViewMode("card")} className={`p-2 ${viewMode === "card" ? "bg-blue-50 text-blue-600" : "bg-white text-slate-400 hover:text-slate-600"}`} data-testid="view-card"><LayoutGrid size={16} /></button>
        <button onClick={() => onViewMode("table")} className={`p-2 ${viewMode === "table" ? "bg-blue-50 text-blue-600" : "bg-white text-slate-400 hover:text-slate-600"}`} data-testid="view-table"><List size={16} /></button>
      </div>
    </div>
  );
}
